import axios from "axios";

const iminioClient = axios.create({
    baseURL: process.env.REACT_APP_IMINIO_BACKEND_API_URL,
    timeout: 30000,
});
let isRefreshingToken = false

const iminioURLs = {
    login: "auth/login",
    refresh: "auth/refresh",
    me: "auth/me",
    change_password: "auth/change_password",
    users: "users",
    admins: "users/admins",
    condominia: 'condominia',
    technical_interventions: "technical_interventions",
}
let accessToken = localStorage.getItem('access')
if (accessToken !== null && accessToken !== 'null')
    iminioClient.defaults.headers['access'] = accessToken

iminioClient.interceptors.response.use(async response => {
    await new Promise((resolve, reject) => { setTimeout(() => { resolve() }, 600) })
    return response
}, async err => {
    if (err?.response?.status === 401) {
        if (isRefreshingToken === true) {
            return await new Promise((resolve, reject) => {
                let refreshInterval = setInterval(() => {
                    console.log("awaiting refresh")
                    if (isRefreshingToken === false) {
                        err.config.headers['access'] = localStorage.getItem('access')
                        resolve(axios.request(err.config))
                        clearInterval(refreshInterval)
                    }
                }, 1000)
            })
        }
        else {
            isRefreshingToken = true
            return await axios.post(`${process.env.REACT_APP_IMINIO_BACKEND_API_URL}${iminioURLs.refresh}`, {
                refresh: localStorage.getItem('refresh')
            }).then(async response => {
                localStorage.setItem('access', response.data.access)
                iminioClient.defaults.headers['access'] = response.data.access
                localStorage.setItem('refresh', response.data.refresh)
                err.config.headers.access = response.data.access
                setTimeout(() => { isRefreshingToken = false }, 200)
                return await axios.request(err.config)
            }).catch(e => {
                if (e?.response?.data?.status?.code === "ERR_INVALID_TOKEN") {
                    localStorage.removeItem('access')
                    localStorage.removeItem('refresh')
                    return window.location.assign('/login')
                }
                throw e
            })
        }
    }
    throw err
})

function parseFilterToUrl(filter) {
    let filterStr = ""
    let keys = Object.keys(filter)
    for (let i = 0; i < keys.length; i++) {
        filterStr += `${keys[i]}=${filter[keys[i]]}&`
    }
    return filterStr
}

export const iminioBackend = {

    async login(email, password) {
        return new Promise((resolve, reject) => {
            iminioClient.post(iminioURLs.login, { email: email, password: password }).then(response => {
                localStorage.setItem('access', response.data.access)
                iminioClient.defaults.headers['access'] = response.data.access
                localStorage.setItem('refresh', response.data.refresh)
                resolve(response.data);
            }).catch(e => {
                console.log(e)
                reject(e)
            })
        })
    },

    async change_password(curr_password, new_password) {
        return new Promise((resolve, reject) => {
            iminioClient.post(iminioURLs.change_password, {
                current_password: curr_password,
                new_password: new_password,
                repeat_password: new_password,
            }).then(response => {
                resolve(response);
            }).catch(e => {
                console.log(e)
                reject(e)
            })
        })
    },

    async me() {
        return new Promise((resolve, reject) => {
            iminioClient.get(iminioURLs.me).then(response => {
                resolve(response.data);
            }).catch(e => {
                console.log(e)
                reject(e)
            })
        })
    },

    async update_me(data) {
        return new Promise((resolve, reject) => {
            iminioClient.put(iminioURLs.me, data).then(response => {
                resolve(response.data);
            }).catch(e => {
                console.log(e)
                reject(e)
            })
        })
    },

    async list_users(page = 1, filter = null) {
        if (filter != null)
            filter = parseFilterToUrl(filter)
        return new Promise((resolve, reject) => {
            iminioClient.get(`${iminioURLs.users}?page=${page}&${filter}`).then(response => {
                resolve(response.data);
            }).catch(e => {
                console.log(e)
                reject(e)
            })
        })
    },

    async list_user_options(filter = null) {
        if (filter != null)
            filter = parseFilterToUrl(filter)
        return new Promise((resolve, reject) => {
            iminioClient.get(`${iminioURLs.users}/options`).then(response => {
                resolve(response.data);
            }).catch(e => {
                console.log(e)
                reject(e)
            })
        })
    },

    async list_admin_users(page = 1, filter = null) {
        if (filter != null)
            filter = parseFilterToUrl(filter)
        return new Promise((resolve, reject) => {
            iminioClient.get(`${iminioURLs.admins}?page=${page}&${filter}`).then(response => {
                resolve(response.data);
            }).catch(e => {
                console.log(e)
                reject(e)
            })
        })
    },

    async list_admin_user_options() {
        return new Promise((resolve, reject) => {
            iminioClient.get(`${iminioURLs.admins}/options`).then(response => {
                resolve(response.data);
            }).catch(e => {
                console.log(e)
                reject(e)
            })
        })
    },

    async create_user(userData) {
        return new Promise((resolve, reject) => {
            iminioClient.post(iminioURLs.users, userData).then(response => {
                resolve(response.data);
            }).catch(e => {
                console.log(e)
                reject(e)
            })
        })
    },

    async create_admin_user(userData) {
        return new Promise((resolve, reject) => {
            iminioClient.post(iminioURLs.admins, userData).then(response => {
                resolve(response.data);
            }).catch(e => {
                console.log(e)
                reject(e)
            })
        })
    },

    async edit_admin_user(userId, userData) {
        return new Promise((resolve, reject) => {
            iminioClient.put(`${iminioURLs.admins}/${userId}`, userData).then(response => {
                resolve(response.data);
            }).catch(e => {
                console.log(e)
                reject(e)
            })
        })
    },

    async edit_user(userId, userData) {
        return new Promise((resolve, reject) => {
            iminioClient.put(`${iminioURLs.users}/${userId}`, userData).then(response => {
                resolve(response.data);
            }).catch(e => {
                console.log(e)
                reject(e)
            })
        })
    },

    async delete_admin_user(userId, userData) {
        return new Promise((resolve, reject) => {
            iminioClient.delete(`${iminioURLs.admins}/${userId}`, userData).then(response => {
                resolve(response.data);
            }).catch(e => {
                console.log(e)
                reject(e)
            })
        })
    },

    async restore_admin_user(userId) {
        return new Promise((resolve, reject) => {
            iminioClient.post(`${iminioURLs.admins}/${userId}/restore`).then(response => {
                resolve(response.data);
            }).catch(e => {
                console.log(e)
                reject(e)
            })
        })
    },

    async delete_user(userId, userData) {
        return new Promise((resolve, reject) => {
            iminioClient.delete(`${iminioURLs.users}/${userId}`, userData).then(response => {
                resolve(response.data);
            }).catch(e => {
                console.log(e)
                reject(e)
            })
        })
    },

    async restore_user(userId) {
        return new Promise((resolve, reject) => {
            iminioClient.post(`${iminioURLs.users}/${userId}/restore`).then(response => {
                resolve(response.data);
            }).catch(e => {
                console.log(e)
                reject(e)
            })
        })
    },

    async reset_user_password(user_id) {
        return new Promise((resolve, reject) => {
            iminioClient.post(`${iminioURLs.users}/${user_id}/reset_password`).then(response => {
                resolve(response.data);
            }).catch(e => {
                console.log(e)
                reject(e)
            })
        })
    },

    async list_condominia(page = 1, filter = null) {
        if (filter != null) {
            filter = parseFilterToUrl(filter)
        }
        return new Promise((resolve, reject) => {
            iminioClient.get(`${iminioURLs.condominia}?page=${page}&${filter}`).then(response => {
                resolve(response.data);
            }).catch(e => {
                console.log(e)
                reject(e)
            })
        })
    },

    async list_all_condominia(filter = null) {
        let filterStr = ""
        if (filter != null) {
            filterStr = parseFilterToUrl(filter)
        }
        return new Promise((resolve, reject) => {
            iminioClient.get(`${iminioURLs.condominia}/options?${filterStr}`).then(response => {
                resolve(response.data);
            }).catch(e => {
                console.log(e)
                reject(e)
            })
        })
    },

    async list_condominia_system_types(filter = null) {
        return new Promise((resolve, reject) => {
            iminioClient.get(iminioURLs.condominia + '/system_types').then(response => {
                resolve(response.data);
            }).catch(e => {
                console.log(e)
                reject(e)
            })
        })
    },

    async create_condominium(newData) {
        return new Promise((resolve, reject) => {
            iminioClient.post(iminioURLs.condominia, newData).then(response => {
                resolve(response.data);
            }).catch(e => {
                console.log(e)
                reject(e)
            })
        })
    },

    async attach_photo_to_condominium(condominium_id, base64) {
        return new Promise((resolve, reject) => {
            iminioClient.post(`${iminioURLs.condominia}/${condominium_id}/photo`, { base64: base64 }).then(response => {
                resolve(response.data);
            }).catch(e => {
                console.log(e)
                reject(e)
            })
        })
    },

    async attach_file_to_condominium(condominium_id, data) {
        return new Promise((resolve, reject) => {
            iminioClient.post(`${iminioURLs.condominia}/${condominium_id}/file`, data).then(response => {
                resolve(response.data);
            }).catch(e => {
                console.log(e)
                reject(e)
            })
        })
    },

    async get_condominium_file(condominium_id) {
        return new Promise((resolve, reject) => {
            iminioClient.get(`${iminioURLs.condominia}/${condominium_id}/file`).then(response => {
                resolve(response.data);
            }).catch(e => {
                console.log(e)
                reject(e)
            })
        })
    },

    async get_condominium_photo(condominium_id) {
        return new Promise((resolve, reject) => {
            iminioClient.get(`${iminioURLs.condominia}/${condominium_id}/photo`).then(response => {
                resolve(response.data);
            }).catch(e => {
                console.log(e)
                reject(e)
            })
        })
    },


    async edit_condominium(id, newData) {
        return new Promise((resolve, reject) => {
            iminioClient.put(`${iminioURLs.condominia}/${id}`, newData).then(response => {
                resolve(response.data);
            }).catch(e => {
                console.log(e)
                reject(e)
            })
        })
    },

    async delete_condominium(id) {
        return new Promise((resolve, reject) => {
            iminioClient.delete(`${iminioURLs.condominia}/${id}`).then(response => {
                resolve(response.data);
            }).catch(e => {
                console.log(e)
                reject(e)
            })
        })
    },

    async restore_condominium(id) {
        return new Promise((resolve, reject) => {
            iminioClient.post(`${iminioURLs.condominia}/${id}/restore`).then(response => {
                resolve(response.data);
            }).catch(e => {
                console.log(e)
                reject(e)
            })
        })
    },

    async list_technical_interventions(page = 1, filter = null) {
        if (filter != null)
            filter = parseFilterToUrl(filter)
        return new Promise((resolve, reject) => {
            iminioClient.get(`${iminioURLs.technical_interventions}?page=${page}&${filter}`).then(response => {
                resolve(response.data);
            }).catch(e => {
                console.log(e)
                reject(e)
            })
        })
    },

    async list_own_technical_interventions(page = 1, filter = null) {
        if (filter != null)
            filter = parseFilterToUrl(filter)
        return new Promise((resolve, reject) => {
            iminioClient.get(`${iminioURLs.technical_interventions}/me?page=${page}&${filter}`).then(response => {
                resolve(response.data);
            }).catch(e => {
                console.log(e)
                reject(e)
            })
        })
    },

    async list_intervention_types() {
        return new Promise((resolve, reject) => {
            iminioClient.get(iminioURLs.technical_interventions + '/types').then(response => {
                resolve(response.data);
            }).catch(e => {
                console.log(e)
                reject(e)
            })
        })
    },

    async list_intervention_categories() {
        return new Promise((resolve, reject) => {
            iminioClient.get(iminioURLs.technical_interventions + '/categories').then(response => {
                resolve(response.data);
            }).catch(e => {
                console.log(e)
                reject(e)
            })
        })
    },

    async create_technical_intervention(newData) {
        return new Promise((resolve, reject) => {
            iminioClient.post(iminioURLs.technical_interventions, newData).then(response => {
                resolve(response.data);
            }).catch(e => {
                console.log(e)
                reject(e)
            })
        })
    },

    async edit_technical_intervention(id, newData) {
        return new Promise((resolve, reject) => {
            iminioClient.put(`${iminioURLs.technical_interventions}/${id}`, newData).then(response => {
                resolve(response.data);
            }).catch(e => {
                console.log(e)
                reject(e)
            })
        })
    },


    async delete_technical_intervention(id) {
        return new Promise((resolve, reject) => {
            iminioClient.delete(`${iminioURLs.technical_interventions}/${id}`).then(response => {
                resolve(response.data);
            }).catch(e => {
                console.log(e)
                reject(e)
            })
        })
    },

    async restore_technical_intervention(id) {
        return new Promise((resolve, reject) => {
            iminioClient.post(`${iminioURLs.technical_interventions}/${id}/restore`).then(response => {
                resolve(response.data);
            }).catch(e => {
                console.log(e)
                reject(e)
            })
        })
    },

    async attach_technical_intervention_photo(id, base64, notes = "") {
        return new Promise((resolve, reject) => {
            iminioClient.post(`${iminioURLs.technical_interventions}/${id}/photo`, {
                base64: base64,
                notes: notes
            }).then(response => {
                resolve(response.data);
            }).catch(e => {
                console.log(e)
                reject(e)
            })
        })
    },

    async edit_technical_intervention_photo_notes(interventionId, photoId, notes = "") {
        return new Promise((resolve, reject) => {
            iminioClient.put(`${iminioURLs.technical_interventions}/${interventionId}/photo/${photoId}`, {
                notes: notes
            }).then(response => {
                resolve(response.data);
            }).catch(e => {
                console.log(e)
                reject(e)
            })
        })
    },

    async get_technical_intervention_photo(interventionId, photoId) {
        return new Promise((resolve, reject) => {
            iminioClient.get(`${iminioURLs.technical_interventions}/${interventionId}/photo/${photoId}`)
                .then(response => {
                    resolve(response.data);
                }).catch(e => {
                    console.log(e)
                    reject(e)
                })
        })
    },

    async delete_technical_intervention_photo(interventionId, photoId) {
        return new Promise((resolve, reject) => {
            iminioClient.delete(`${iminioURLs.technical_interventions}/${interventionId}/photo/${photoId}`)
                .then(response => {
                    resolve(response.data);
                }).catch(e => {
                    console.log(e)
                    reject(e)
                })
        })
    },

    async download_technical_intervention_pdf(interventionId) {
        return new Promise((resolve, reject) => {
            iminioClient.get(`${iminioURLs.technical_interventions}/${interventionId}/pdf`, {
                responseType: 'blob'
            }).then(response => {
                const blob = new Blob([response.data], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `intervento_${interventionId}.pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                resolve(response.data);
            }).catch(e => {
                console.log(e)
                reject(e)
            })
        })
    },

}